import { Container, Button, Text } from '../../..'
import { mainSelectors } from '../../../../state/ducks'
import { hooks } from '../../../../state/utils'
import { LoadingSpinner } from 'assets'
import StyledWorkbookTerritories from './workbook-territories-styled'
import WorkBookElementsList from 'components/layout/dashboard/workbook-download/workbook-elements-list'
import { Spinner } from '../../../shared/ui-elements/spinner'
import { formatDate } from '../../../../utils'
import React, { useEffect, useState } from 'react';
import Retool from 'react-retool'
import { getUserFromSubcookies } from 'utils/tools'
import { mainOperations, store } from 'state';
import ConfirmDialog from '../../../shared/ConfirmDialog';


const { useAppSelector } = hooks;
interface Props {
  onBack: () => void;
  selectedTerritoryGuid?: string | null;
  onUnsavedChangesChange?: (hasChanges: boolean) => void;
}

export const WorkbookTerritories: React.FC<Props> = ({ onBack, selectedTerritoryGuid, onUnsavedChangesChange }) => {

  const { useAppSelector, useAppDispatch } = hooks;
  const { selectmain } = mainSelectors;
  const {
    saveWorkbookFilters,
    updateSelectedFilterSaved,
    updateDefaultFilterSaved,
    showWorkbookActions,
    getSigmaFilters,
    getSavedWorkbookFilters,
  } = mainOperations;
  const { selectedWorkbookV2} = useAppSelector(selectmain);
  const dispatch = useAppDispatch();
  
  const [showUnsavedChangesDialog, setShowUnsavedChangesDialog] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const sigmaMap = (selectedWorkbookV2?.sigmaControls || []).reduce(
    (acc: Record<string, string>, ctrl: { sigmaControlId: string; values: string }) => {
      acc[ctrl.sigmaControlId] = ctrl.values;
      return acc;
    },
    {}
  );

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (typeof event.data === "string") {
        if (
          event.data === "TerritoryCreated" ||
          event.data === "TerritoryUpdated"
        ) {
          setTimeout(() => {
            onBack();
          }, 1500);
        } else if (event.data === "UnsavedChanges") {
          setHasUnsavedChanges(true);
          onUnsavedChangesChange?.(true);
        }
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [onBack]);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        event.preventDefault();
        event.returnValue = '';
        return '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  useEffect(() => {
    onUnsavedChangesChange?.(hasUnsavedChanges);
  }, [hasUnsavedChanges, onUnsavedChangesChange]);

  const handleBackClick = () => {
    if (hasUnsavedChanges) {
      setShowUnsavedChangesDialog(true);
    } else {
      onBack();
    }
  };

  const handleConfirmExit = () => {
    setShowUnsavedChangesDialog(false);
    setHasUnsavedChanges(false);
    onUnsavedChangesChange?.(false);
    onBack();
  };

  const handleCancelExit = () => {
    setShowUnsavedChangesDialog(false);
  };

  const iframeData = {
    state: sigmaMap["ctrl_STATE_CODE"] || "",
    brand: sigmaMap["ctrl_BRAND"] || "",
    county: sigmaMap["ctrl_COUNTY"] || "",
    parentRetailer: sigmaMap["ctrl_PARENT_RETAILER"] || "",
    retailer: sigmaMap["ctrl_STORE_NAME"] || "",
    userGuid: getUserFromSubcookies().profile?.sub || "",
    territoryGuid: selectedTerritoryGuid || "",
    iframeHeight: '117'
  };

  // Map REACT_APP_ENVIRONMENT to the corresponding Retool environment
  const getRetoolEnvironment = () => {
    const environment = process.env.REACT_APP_ENVIRONMENT;
    switch (environment) {
      case 'dev':
        return 'development';
      case 'staging':
        return 'staging';
      case 'prod-insights':
        return 'production';
      default:
        return 'development';
    }
  };

  const url = `https://retool.pistildata.com/embedded/public/9cab4eb7-a4ae-468a-83f3-e792a0723cfa?_environment=${getRetoolEnvironment()}`;

  return (
      <StyledWorkbookTerritories className="workbook-territories">

        <Retool
          url={url}
          data={iframeData}
          allow="geolocation"
          onData={(data: any) => data}
          className="embed-territories"
        />
        <>
          <Button onClick={handleBackClick} className="back-button">
            <Text>← Back to Territory List</Text>
          </Button>
        </>

        <ConfirmDialog
          isOpen={showUnsavedChangesDialog}
          title="You have unsaved changes"
          message="You have unsaved changes. Are you sure you want to leave? Your changes will be lost."
          onConfirm={handleConfirmExit}
          onCancel={handleCancelExit}
          confirmText="Leave without saving"
          cancelText="Continue editing"
        />

      </StyledWorkbookTerritories>
  );
};

export default WorkbookTerritories;
